module.exports = __webpack_public_path__ + "static/media/commingSoon.df1a8e5d.gif";